var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10C19.25 4.89137 15.1086 0.75 10 0.75C4.89137 0.75 0.75 4.89137 0.75 10C0.75 15.1086 4.89137 19.25 10 19.25C15.1086 19.25 19.25 15.1086 19.25 10Z",
    stroke: "#616161",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3519 11.9671L11.3752 9.9915L13.3508 8.01595C13.7308 7.63706 13.7308 7.02039 13.3508 6.6415C12.9708 6.25928 12.3563 6.26039 11.9763 6.64039L9.99967 8.61595L8.023 6.63817C7.643 6.25817 7.02745 6.26039 6.64745 6.63817C6.26856 7.01817 6.26856 7.63484 6.64745 8.01373L8.62523 9.9915L6.65189 11.9637C6.27189 12.3437 6.27189 12.9604 6.65189 13.3382C6.84189 13.5293 7.08967 13.6237 7.33856 13.6237C7.58856 13.6237 7.83634 13.5293 8.02634 13.3393L9.99967 11.3659L11.9774 13.3426C12.1674 13.5326 12.4152 13.6271 12.6641 13.6271C12.913 13.6271 13.1619 13.5315 13.3519 13.3426C13.7319 12.9626 13.7319 12.3471 13.3519 11.9671Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f5876f500ea9a07a47832ed6a48379a8.svg";
export { ForwardRef as ReactComponent };